import { Directive, Signal, inject } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

export class ChartBinding {
  public chart?: Signal<Highcharts.Chart>;
  public chart$: Subject<Highcharts.Chart> = new ReplaySubject(1);
}

/**
 * Provides access to a highcharts chart instance contained in any child.
 */
@Directive({
  selector: '[chartBinding]',
  standalone: true,
  providers: [
    {
      provide: ChartBinding,
      useFactory: () => new ChartBinding(),
    },
  ],
})
export class ChartBindingDirective {
  public get chart(): Highcharts.Chart | null {
    return this.binding.chart();
  }

  public readonly binding: ChartBinding = inject(ChartBinding);
}
